import { render, staticRenderFns } from "./PublicAssistanceForm.vue?vue&type=template&id=c5a48728"
import script from "./PublicAssistanceForm.vue?vue&type=script&lang=js"
export * from "./PublicAssistanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports